import { InjectionToken } from '@angular/core';

export const PROFILE_PICTURE_FALLBACK = new InjectionToken<string>('PROFILE_PICTURE_FALLBACK');
